// トリガー要素とターゲット要素を指定することでターゲット要素の表示を切り替え
import commonClass from "./commonClass";

export default class switchShowClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }

  // class変数定義
  _classValiableDefine() {
    //トリガー要素とターゲット要素の両方を包含している要素
    this._parentSelector = '.js-switchshow_prt';
    //同一data属性をもつターゲットを表示するためのトリガー
    this._triggerSelector = '.js-switchshow_trg';
    //同一data属性をもつトリガーが活性化した際に表示されるターゲット
    this._targetSelector = '.js-switchshow_tgt';
  }

  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;
    this.switchShow();
    $(cls._parentSelector).on('change',function(){
      cls.switchShow();
    })
  }

  switchShow(){
    var cls = this;
    var $parent = $(cls._parentSelector);
    //トリガー要素を絞り込み
    var $triggerObjData = $parent.find(`${cls._triggerSelector}:checked`).data('switch');

    //全てのターゲット要素に対して処理を実行
    var $targetObjAll = $parent.find(cls._targetSelector);
    $targetObjAll.each(function(index, element) {
      //data-switchがトリガーと一致したら表示
      if ($(element).data('switch') === $triggerObjData) {
        $(element).show();
      }
      //一致しなければ非表示
      else {
        $(element).hide();
      }
    });
  }
}